export default __webpack_public_path__ + "static/media/earlysketch.727545ba.jpg";